import React from 'react';
import { formatNumber } from '../../services';
import * as S from './claim-financial-summary.styles';
import { ClaimFinancialSummaryData } from './claim-financial-summary.utils';

const formatAmount = formatNumber('Currency');

interface IFinancialCardProps {
    title: string;
    value: number;
    highlighted?: boolean;
}

const FinancialCard: React.FC<IFinancialCardProps> = ({ title, value, highlighted }) => (
    <S.FinancialCard $highlighted={highlighted}>
        <S.FinancialCardTitle $highlighted={highlighted}>{title}</S.FinancialCardTitle>
        {/* A zero in the highlighted tile is still the answer (nothing outstanding), so it is not dimmed. */}
        <S.FinancialCardValue $isZero={value === 0 && !highlighted}>{formatAmount(value)}</S.FinancialCardValue>
    </S.FinancialCard>
);

interface IClaimFinancialSummaryProps {
    financials: ClaimFinancialSummaryData;
}

export const ClaimFinancialSummary: React.FC<IClaimFinancialSummaryProps> = ({ financials }) => (
    <S.FinancialCardsRow>
        <FinancialCard title="Charge" value={financials.charge} />
        <FinancialCard title="Contract Value" value={financials.contractValue} />
        <FinancialCard title="Allowed" value={financials.allowed} />
        <FinancialCard title="Payer Paid" value={financials.payerPaid} />
        <FinancialCard title="Patient Resp." value={financials.patientResponsibility} />
        <FinancialCard title="Patient Paid" value={financials.patientPaid} />
        <FinancialCard title="Outstanding" value={financials.outstanding} highlighted />
    </S.FinancialCardsRow>
);
